import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {LocalizationProvider, ThemeProvider} from "@shifath/platform-admin-core";
import {AppRouter} from "./composition/app_router";
import {createAppRuntime} from "./composition/app_runtime";
import "@shifath/platform-admin-core/theme.css";
const root = document.getElementById("root");
if (!root) throw new Error("Root element missing");
createRoot(root).render(<StrictMode><ThemeProvider><LocalizationProvider><AppRouter runtime={createAppRuntime()}/></LocalizationProvider></ThemeProvider></StrictMode>);
